import { render, staticRenderFns } from "./dmca.vue?vue&type=template&id=7ab83988&scoped=true"
import script from "./dmca.vue?vue&type=script&lang=js"
export * from "./dmca.vue?vue&type=script&lang=js"
import style0 from "./dmca.vue?vue&type=style&index=0&id=7ab83988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab83988",
  null
  
)

export default component.exports